import { BusClass } from '~/apiClient';
import { PlatformBusClass } from '~/types/asset.type';

const BUS_CLASS_TO_PLATFORM_BUS_CLASS_MAPPING: Record<BusClass, PlatformBusClass[]> = {
    [BusClass.ClassOne]: [PlatformBusClass.City],
    [BusClass.ClassTwo]: [PlatformBusClass.Intercity],
    [BusClass.ClassThree]: [PlatformBusClass.Touristic],
    [BusClass.ClassA]: [PlatformBusClass.City],
    [BusClass.ClassB]: [PlatformBusClass.Intercity, PlatformBusClass.Touristic],
    [BusClass.SchoolBus]: [PlatformBusClass.SchoolBus],
} as const;

export const getPlatformBusClassesFromBusClass = (busClass: BusClass): PlatformBusClass[] =>
    BUS_CLASS_TO_PLATFORM_BUS_CLASS_MAPPING[busClass as keyof typeof BUS_CLASS_TO_PLATFORM_BUS_CLASS_MAPPING];

export const getMainPlatformBusClassFromBusClass = (busClass: BusClass): PlatformBusClass => getPlatformBusClassesFromBusClass(busClass)[0];

export const getBusClassesFromPlatformBusClass = (platformBusClass: PlatformBusClass): BusClass[] =>
    Object.values(BusClass).filter((_busClass: BusClass) => BUS_CLASS_TO_PLATFORM_BUS_CLASS_MAPPING[_busClass].includes(platformBusClass));

export const getBusClassesFromPlatformBusClasses = (platformBusClasses: PlatformBusClass[]): BusClass[] => [
    ...new Set(platformBusClasses.map(pbc => getBusClassesFromPlatformBusClass(pbc)).flat()),
];
